export default __webpack_public_path__ + "static/media/kitchen.ae2fa67f.png";